module.exports = __webpack_public_path__ + "static/parade-2022-2-c259094ba34580afc4e16ada99545c44.jpg";